<template>
  <v-container fluid class="ScheduleBSettings">
    <v-layout>
      <v-btn
        :disabled="getDataLoading"
        color="primary"
        @click="handleScheduleB(false)"
        >{{ $t('addCommonCommodity') }}
      </v-btn>
      <template v-if="isMod">
        <v-btn color="primary" @click="cancelEdit">{{ $t('cancel') }} </v-btn>
        <v-btn
          :loading="saveLoading"
          color="primary"
          @click="submit"
          >{{ $t('save') }}
        </v-btn>
      </template>
      <v-btn
        v-else
        color="primary"
        :disabled="!commonCommodities.length || getDataLoading"
        @click="handleScheduleB(true)"
        >{{ $t('editCommonCommodity') }}
      </v-btn>
      <v-spacer></v-spacer>
      <v-flex md2 xs4>
        <v-select
          style="paddingTop: 0"
          v-model="commonCommodityFilter"
          :items="commonCommodities"
          :label="$t('commonCommodityFilter')"
          item-text="description"
          item-value="description"
          clearable
        ></v-select>
      </v-flex>
    </v-layout>

    <v-form ref="form">
      <v-data-table :headers="headers" :items="tableData">
        <template v-slot:items="props">
          <td class="text-xs-left">
            <template v-if="!isMod">{{ props.item.description }}</template>
            <v-text-field
              v-else
              v-model.trim="props.item.description"
              clearable
              :label="$t('description')"
              :rules="[validDesc(props.index)]"
              required
            />
          </td>
          <td class="text-xs-left">
            <template v-if="!isMod">{{ props.item.code }}</template>
            <v-text-field
              v-else
              v-model.trim="props.item.code"
              clearable
              :label="$t('code')"
              :rules="[fieldIsRequired()]"
              required
            />
          </td>
          <td class="text-xs-left">
            <template v-if="!isMod">{{ props.item.hsCode }}</template>
            <v-text-field
              v-else
              v-model.trim="props.item.hsCode"
              clearable
              :label="$t('hsCode')"
              :rules="[fieldIsRequired()]"
              required
            />
          </td>
          <td class="text-xs-left" v-if="isMod">
            <v-layout justify-center>
            <v-btn color="primary" flat icon @click="deleteScheduleB(props.index)">
              <v-icon color="lighten-2">delete</v-icon>
            </v-btn></v-layout>
          </td>
        </template>
      </v-data-table>
    </v-form>
  </v-container>
</template>

<script>
import { checkRules, cloneDeep } from '@/utils/tools'
import { mapGetters, mapActions } from 'vuex'
export default {
  name: 'ScheduleBSettings',
  mixins: [checkRules],
  data () {
    return {
      isMod: false,
      cacheData: [],
      commonCommodityFilter: '',
      getDataLoading: false,
      saveLoading: false
    }
  },
  computed: {
    headers () {
      const headers = [
        { text: this.$t('description'), value: 'description', width: '50%', sortable: false },
        { text: this.$t('code'), value: 'code', sortable: false },
        { text: this.$t('hsCode'), value: 'hsCode', sortable: false }
      ]
      if (this.isMod) {
        headers.push({
          text: this.$t('actions'),
          value: 'actions',
          width: '120px',
          align: 'center',
          sortable: false
        })
      }
      return headers
    },
    tableData () {
      if (this.isMod) return this.cacheData
      return this.commonCommodities.filter(item => !this.commonCommodityFilter || item.description.includes(this.commonCommodityFilter))
    },
    ...mapGetters(['commonCommodities'])
  },
  created () {},
  methods: {
    ...mapActions(['updateSysAdminCommonCommoditiesList']),
    async submit () {
      const valid = this.$refs.form.validate()
      if (!valid) return
      this.saveLoading = true
      try {
        await this.updateSysAdminCommonCommoditiesList({ commonCommodities: this.cacheData })
        this.saveLoading = false
        this.isMod = false
        this.cacheData = []
      } catch (err) {
        console.log(err)
        this.saveLoading = false
      }
    },
    cancelEdit () {
      this.isMod = false
    },
    handleScheduleB (isMod = false) {
      if (!this.isMod) this.cacheData = this.copyData()
      if (!isMod) this.cacheData.unshift(this.initData())
      this.isMod = true
      this.commonCommodityFilter = ''
      this.$refs.form.resetValidation()
    },
    deleteScheduleB (index) {
      if (!this.isMod) return
      this.cacheData.splice(index, 1)
    },
    copyData () {
      return cloneDeep(this.commonCommodities)
    },
    validDesc (index) {
      return v => {
        if (!v) return this.$t('fieldIsRequired', { fieldName: 'This field' })
        const dupDesc = this.cacheData.find((item, i) => item.description === v && index !== i)
        return !dupDesc || this.$t('dupDesc')
      }
    },
    initData () {
      return {
        description: '',
        code: '',
        hsCode: ''
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/CommonCommoditySettings.vue